<template>
  <div class="px-4 ml-6 py-4 layout-row layout-wrap">

    <!-- Kopfdaten -->

    <div class="flex-gt-sm-100 flex-100 mt-2">
      <div class="flex-100 px-3 py-1 mb-3 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.REPORTER_PERSONAL_CONTRIBUTION') }}</span>
      </div>

      <melder path="headerData"
              v-model="model.headerData"
              :formKey="model.formType"
              :additionalItemsList="additionalItemsList"
              :validationRef="validationRef"
              :isImport="true"
              :disableManuallyValidate="true"
      ></melder>
    </div>

    <!-- Grunddaten -->

    <div class="flex-100 px-3 py-1 my-6 mx-2"
         :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_HEADER') }}</span>
    </div>

    <div v-if="SystemicTherapyWithSameDateAlreadyExists" class="flex-gt-sm-100 mx-2 mb-6 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
         :class="[!compColor.isInDarkMode ? allColors['deep-orange'].prime + ' lighten-5 white--text ' : '']"
         :style="{'border-color': compColor.isInDarkMode ? allColors['deep-orange'].primeHighlightColor : 'transparent'}">
      <div class="layout-column layout-align-center-center mr-3">
        <v-icon size="30" :color="allColors['deep-orange'].prime">warning</v-icon>
      </div>
      <span style="font-size: 14px;" v-bind:class="allColors['deep-orange'].primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE_WARNING') }}</span>
    </div>

    <!-- Datumsgenauigkeit Therapiebeginn Datum -->

    <div class="flex-gt-sm-50 flex-100 px-2 layout-row" v-show="model.reportType==='behandlungsbeginn'">
      <validation-provider tag="div"
                           class="flex"
                           :name="path + '.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit'"
                           :ref="path + '.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE_ACCURACY') + ' *'"
          v-model="model.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit"
          :items="DateAccuracyTypes"
          outlined
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>

      <v-tooltip bottom open-delay="1000">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
               style="cursor: pointer;">
            <v-icon :color="compColor.prime" medium>info</v-icon>
          </div>
        </template>
        <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
      </v-tooltip>
    </div>

    <!-- Grund Ende wenn Therapieende (bei Therapieende)-->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="model.reportType==='behandlungsende'">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.systemicTherapy.syst_ende_grund'"
                           :ref="path + '.additionalFields.systemicTherapy.syst_ende_grund'"
                           :rules="{required: model.date }"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_SYST_REASON_FOR_END') + ' *'"
          v-model="model.additionalFields.systemicTherapy.syst_ende_grund"
          :items="SYST_Ende_GrundTypes"
          outlined
          @change="setSideEffectsPerDefault(model.additionalFields.systemicTherapy.syst_ende_grund)"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Datum Beginn wenn Therapieende, ansonsten ist model.date Datum Beginn -->

    <div class="flex-100 px-2 mb-4" v-if="model.reportType==='behandlungsende'">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_BEGINN_OF_THERAPY')">
        <div class="layout-row px-2 py-2 layout-wrap">

          <!-- Soll verlinkt werden ? -->

          <div class="flex-100 mb-2 layout-row">
            <v-radio-group :dense="denseFields" v-model="isLinkedTherapy" row hide-details
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_LINK')"
                       :disabled="listOfUnlinkedTherapies.length === 0"
                       value="J" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_MANUALLY_INPUT')"
                       @change="unlinkTherapy"
                       value="N" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Therapiebeginn Datum -->

          <div class="flex-gt-sm-50 flex-100 px-1 mt-2" v-show="isLinkedTherapy !== 'J'">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.systemicTherapy.syst_beginn_datum'"
                                 :ref="path + '.additionalFields.systemicTherapy.syst_beginn_datum'"
                                 :rules="{required:isLinkedTherapy!== 'J',german_date:true,date_not_in_future:true,date_must_be_lesser_than:model.date,date_must_be_lesser_than_death:[deathOfDeath,model.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit]}"
                                 v-slot="{ errors }">
              <lx-datepicker
                :color="compColor.textInput"
                :name="path + '.additionalFields.systemicTherapy.syst_beginn_datum'"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE') + ' *'"
                class="mb-4"
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error="errors[0]"
                v-model="model.additionalFields.systemicTherapy.syst_beginn_datum"
              ></lx-datepicker>
            </validation-provider>
          </div>

          <!-- Verlinkter Therapiebeginn -->

          <div class="flex-gt-sm-50 flex-100 px-1 mt-2" v-show="isLinkedTherapy === 'J'">
            <validation-provider tag="div"
                                 :name="path + '.linked_therapy'"
                                 :ref="path + '.linked_therapy'"
                                 :rules="{required: isLinkedTherapy === 'J'}"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY') + ' *'"
                v-model="model.linked_therapy"
                :items="listOfUnlinkedTherapies"
                outlined
                @change="setBaseDataOfLinkedTherapy"
                :item-text="formatDateOfSystemicTherapy"
                item-value="_id"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ formatDateOfSystemicTherapy(item) }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Datumsgenauigkeit Therapiebeginn Datum -->

          <div class="flex-gt-sm-50 flex-100 px-2 layout-row mt-2">
            <validation-provider tag="div"
                                 class="flex"
                                 :name="path + '.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit'"
                                 :ref="path + '.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                  :color="compColor.primeColor"
                  :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_START_DATE_ACCURACY') + ' *'"
                  v-model="model.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit"
                  :items="DateAccuracyTypes"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>

            <v-tooltip bottom open-delay="1000">
              <template v-slot:activator="{ on }">
                <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
                     style="cursor: pointer;">
                  <v-icon :color="compColor.prime" medium>info</v-icon>
                </div>
              </template>
              <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
            </v-tooltip>
          </div>

          <div v-if="!!model.linked_therapy && model.reportType === 'behandlungsbeginn'" class="flex-gt-sm-100 pa-3 mb-2 mx-1 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY_MESSAGE') }}</span>
          </div>

          <div v-if="isLinkedTherapy === 'J' && model.reportType === 'behandlungsende'" class="flex-gt-sm-100 pa-3 mb-2 mx-1 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY_MESSAGE_IMPORT') }}</span>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <div class="flex-100 px-2 mb-4 mt-2">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_INTENSION')">
        <div class="layout-row layout-wrap">

          <!-- Message to Intention and Stellung zu operativer Therapie -->

          <div class="flex-gt-sm-100 mx-2 mt-4 mb-5 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.BASE_SYSTEMIC_THERAPY_INTENTION_MESSAGE') }}</span>
          </div>

          <!-- Intention -->

          <div class="flex-gt-sm-50 flex-100 px-2">
            <validation-provider tag="div"
                                 :name="path + '.syst_intention'"
                                 :ref="path + '.syst_intention'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_INTENTION') + ' *'"
                v-model="model.additionalFields.systemicTherapy.syst_intention"
                :items="SYST_IntentionTypes"
                outlined
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Stellung zu operativer Therapie -->

          <div class="flex-gt-sm-50 flex-100 px-2">
            <validation-provider tag="div"
                                 :name="path + '.syst_stellung_op'"
                                 :ref="path + '.syst_stellung_op'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_POSITION_TO_OP') + ' *'"
                v-model="model.additionalFields.systemicTherapy.syst_stellung_op"
                :items="ST_Stellung_OPTypes"
                outlined
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Protokoll / Wirkstoffe -->

    <div class="flex-100 px-2 mb-6 mt-2">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_AGENTS')">
        <div class="layout-row layout-wrap">

          <!-- Protokoll -->

          <div class="flex-gt-sm-50 flex-100 px-2 mt-4">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.systemicTherapy.syst_protokoll'"
                                 :ref="path + '.additionalFields.systemicTherapy.syst_protokoll'"
                                 rules="trim_string"
                                 v-slot="{ errors }">
              <lx-autocomplete
                :label="$t('FORMS_DIVERSE.MODULE_SYST_PROTOCOL')"
                v-model="model.additionalFields.systemicTherapy.syst_protokoll"
                :error="errors[0]"
                :disabled="model.additionalFields.systemicTherapy.syst_no_agent"
                @search-method="getProtocolForAutocomplete"
                @input="setProtocol"
                :dense="denseFields"
                :results="resultSearchProtocolModel">
                <template v-slot="slotProps">
                  <div class="layout-row">
                    <div style="width: 250px;border-radius: 4px;"
                         class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                      <h4>
                        <lx-text-highlight :text="slotProps.lineItem.protocol"
                                           :search-string="slotProps.searchText"
                                           :color="compColor.prime"></lx-text-highlight>
                      </h4>
                    </div>
                    <div class="flex">
                <span class="body-2">
                  <lx-text-highlight :text="setTextForAgentsInList(slotProps.lineItem.agents)" :search-string="slotProps.searchText"
                                     :color="compColor.prime"></lx-text-highlight>
                </span>
                    </div>
                  </div>
                </template>
              </lx-autocomplete>
            </validation-provider>
          </div>

          <div class="flex-gt-sm-50 flex-100"></div>

          <!-- Wirkstoffe -->

          <div class="flex-gt-sm-100 flex-100 px-2 py-1">
            <!-- hidden input field to show error, if array of agents is empty -->
            <validation-provider tag="div"
                                 :name="path + '.agents'"
                                 :ref="path + '.agents'"
                                 :rules="{ at_least_one_agent_is_selected: [model.additionalFields.systemicTherapy.syst_no_agent, kindOfTherapyIsPassive]}"
                                 v-slot="{ errors }">
              <lx-alert-box v-show="errors[0]" color="red" class="my-2">
                {{ $t('ERROR_EMPTY_AGENTS_ARRAY') }}
              </lx-alert-box>

              <v-text-field
                v-model="model.agents"
                v-show="false"
                :dense="denseFields"
                outlined
                hide-details
                :error-messages="errors[0]"
              ></v-text-field>
            </validation-provider>
          </div>

          <div class="layout-column flex-gt-sm-100 flex-100">
            <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center layout-row pb-1 pt-0 px-2">
              <lx-btn icon="add_circle"
                      :color="compColor.primeColor"
                      :iconColor="'white'"
                      :disabled="therapiesWithoutAgents.indexOf(model.additionalFields.systemicTherapy.syst_therapieart) > -1 || model.additionalFields.systemicTherapy.syst_no_agent"
                      :tooltip="$t('FORMS_DIVERSE.MODULE_SYST_ADD_NEW_THERAPY_AGENT')"
                      :label="$t('FORMS_DIVERSE.MODULE_SYST_ADD_NEW_THERAPY_AGENT')"
                      iconSize="21"
                      :width="'auto'"
                      :height="35"
                      classes="text-none mb-1"
                      @click="addNewAgent()"
              ></lx-btn>

              <v-checkbox :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          hide-details
                          :label="$t('FORMS_DIVERSE.MODULE_SYST_NO_AGENT')"
                          class="ml-5 mt-0 mb-1"
                          @change="resetNoAgents(model.additionalFields.systemicTherapy.syst_no_agent)"
                          v-model="model.additionalFields.systemicTherapy.syst_no_agent">
              </v-checkbox>
            </div>

            <div v-for="(item, index) in model.agents"
                 :key="index"
                 class="layout-row pa-0 ma-2"
                 :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
                 style="border-radius:4px;"
                 :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

              <div class="layout-row layout-wrap flex px-3">
                <div class="flex-gt-sm-50 flex-100 px-2 py-3">
                  <validation-provider tag="div"
                                       :name="path + '.agents.' + index + '.bezeichnung'"
                                       :ref="path + '.agents.' + index + '.bezeichnung'"
                                       :rules="{agent_must_be_unique: [model.agents], required: true, trim_string: true}"
                                       v-slot="{ errors }">
                    <lx-autocomplete
                      :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_AGENT') + ' *'"
                      v-model="item.bezeichnung"
                      :error="errors[0]"
                      @search-method="getDataForAutocomplete"
                      @input="setAgent"
                      :length="3"
                      :dense="denseFields"
                      :hide-details="!errors || errors.length <= 0"
                      :index="index"
                      :results="resultSearchModel">
                      <template v-slot="slotProps">
                        <div class="layout-row">
                          <div style="width: 300px;border-radius: 4px; word-wrap: normal;"
                               class="mr-2 px-2 white lighten-2 layout-column layout-align-center-start">
                            <h3>
                              <lx-text-highlight :text="slotProps.lineItem.Name_deutsch || ''"
                                                 :search-string="slotProps.searchText"
                                                 :color="compColor.prime"></lx-text-highlight>
                            </h3>
                          </div>
                          <div class="flex">
                          <span class="body-2">
                            <lx-text-highlight :text="slotProps.lineItem.Key_ATC || ''" :search-string="slotProps.searchText"
                                               :color="compColor.prime"></lx-text-highlight>
                          </span>
                          </div>
                        </div>
                      </template>
                    </lx-autocomplete>
                  </validation-provider>
                </div>

                <div class="flex-gt-sm-50 flex-100 px-2 py-3" v-if="item.atc">
                  <validation-provider tag="div"
                                       :name="path + '.agents.' + index + '.atc.code'"
                                       :ref="path + '.agents.' + index + '.atc.code'"
                                       rules=""
                                       v-slot="{ errors }">
                    <v-text-field
                      label="ATC-Code"
                      v-model="item.atc.code"
                      :dense="denseFields"
                      outlined
                      class="ma-0"
                      hide-details
                      disabled
                      :dark="compColor.isInDarkMode"
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </validation-provider>
                </div>
              </div>

              <div class="layout-column layout-align-center-center px-3"
                   :class="{'grey lighten-2': !compColor.isInDarkMode}"
                   :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
                  <lx-btn @click="deleteItem('agents', index)"
                          :color="compColor.primeColor"
                          :iconColor="'white'"
                          iconSize="21"
                          :width="35"
                          :height="35"
                          :disabled="model.agents.length === 1"
                          icon="delete_forever"></lx-btn>
              </div>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Therapieart -->

    <div class="flex-100 px-2 mb-2">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.systemicTherapy.syst_therapieart'"
                           :ref="path + '.additionalFields.systemicTherapy.syst_therapieart'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_KIND_OF_THERAPY') + ' *'"
          v-model="model.additionalFields.systemicTherapy.syst_therapieart"
          :items="selectionForKindOfTherapy"
          outlined
          @change="clearProtocol(model.additionalFields.systemicTherapy.syst_therapieart)"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>

      <!-- Info wenn Protokoll vorhanden und Therapieart disabled ist -->

      <div v-if="!!model.additionalFields.systemicTherapy.syst_protokoll && !!model.additionalFields.systemicTherapy.syst_therapieart" class="flex-gt-sm-100 mb-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
           :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
        </div>
        <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_PROTOCOL_EXISTS_MESSAGE') }}</span>
      </div>

      <!-- Info wenn Wirkstoffe aber keine Applikationsart vorhanden -->

      <div v-if="model.agents && model.agents.length > 0 && !model.additionalFields.systemicTherapy.syst_therapieart" class="flex-gt-sm-100 mb-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
           :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
        </div>
        <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_NO_KIND_OF_THERAPY_MESSAGE') }}</span>
      </div>
    </div>

    <!--  Nebenwirkungen (bei Therapieabbruch wegen Nebenwirkungen) -->

    <div class="flex-gt-sm-100 flex-100 mt-4 px-2">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_CTCAE_HEADER') + ' *'" class="pb-2">
        <nebenwirkungen path="additionalFields.systemicTherapy.syst_nebenwirkung"
                        v-model="model.additionalFields.systemicTherapy.syst_nebenwirkung"
                        :addCtcaeItem="addItem"
                        :isRequired="true"
                        :validationRef="validationRef"
                        :deleteCtcaeItem="deleteItem"
                        :disableManuallyValidate="true"
        ></nebenwirkungen>
      </fake-input-frame>
    </div>

    <!--  ANMERKUNG  -->

    <div class="flex-gt-sm-100 flex-100 mt-6">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.ANNOTATION_HEADER') }}</span>
      </div>

      <anmerkung path="additionalFields.systemicTherapy.anmerkung"
                 :isDisabled="isFormDisabled()"
                 v-model="model.additionalFields.systemicTherapy.anmerkung"
                 class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
    </div>
  </div>
</template>

<script>
import utils from '../../../common/utils'
import metaData from '../../../components/documentation/shared/formsMetaData'

import LxAutocomplete from '../../../components/lx_auto_complete/LxAutocomplete'
import Nebenwirkungen from '../../../components/documentation/shared/Nebenwirkungen'
import Melder from '../../../components/documentation/shared/Melder'
import lodash from 'lodash'
import moment from 'moment'
import Anmerkung from '../../../components/documentation/shared/Anmerkung.vue'

export default {
  name: "SystemicTherapy",
  mixins: [utils, metaData],
  components: {
    Anmerkung,
    LxAutocomplete,
    Nebenwirkungen,
    Melder
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        additionalFields: {
          systemicTherapy: {}
        }
      })
    },
    path: {
      type: String
    },
    recentForms: {
      type: Array,
      default: () => ([])
    },
    unlinkedRecentSystemicTherapies: {
      type: Array,
      default: () => ([])
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    date: {
      type: [Object, String]
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    deathOfDeath: {
      type: String
    }
  },
  data () {
    return {
      model: {
        additionalFields: {
          systemicTherapy: {}
        }
      },
      resultSearchModel: {},
      resultSearchProtocolModel: {},
      SYST_Ende_GrundTypes: null,
      SYST_IntentionTypes: null,
      ST_Stellung_OPTypes: null,
      SYST_TherapyArtTypes: null,
      DateAccuracyTypes: null,
      oldProtocolData: {},
      isLinkedTherapy: false,
      therapiesWithoutAgents: ['SZ', 'WS', 'AS', 'WW'],
      therapiesWithoutAgentsList: []
    }
  },
  created () {
    this.SYST_Ende_GrundTypes = this.formsMetaData.SYST_Ende_GrundTypes
    this.SYST_IntentionTypes = this.formsMetaData.SYST_IntentionTypes
    this.ST_Stellung_OPTypes = this.formsMetaData.ST_Stellung_OPTypes
    this.SYST_TherapyArtTypes = this.formsMetaData.SYST_TherapyArtTypes
    this.therapiesWithoutAgentsList = this.formsMetaData.SYST_Passive_TherapyArtTypes
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyShort
  },
  methods: {
    /**
     * set required-state in dependency to agents-array and kind of therapies
     */
    atLeastOneAgentIsSelected () {
      let agentsList = lodash.cloneDeep(this.model.agents)
      agentsList = agentsList || []

      // agents-array is invalid if empty or the first and only element is an empty string
      const invalidAgentsArray = agentsList.length === 0 || (agentsList.length === 1 && !agentsList[0].bezeichnung)

      return invalidAgentsArray && this.model.additionalFields.systemicTherapy.syst_therapieart && this.therapiesWithoutAgents.indexOf(this.model.additionalFields.systemicTherapy.syst_therapieart) === -1
    },

    /**
     * Set base date af therapy with "behandlungsende" after link to start therapy
     */
    setBaseDataOfLinkedTherapy () {
      const selectedForm = this.recentForms.find(form => form.uuid === this.model.linked_therapy)

      if (selectedForm) {
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_stellung_op', selectedForm.additionalFields.systemicTherapy.syst_stellung_op)
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_intention', selectedForm.additionalFields.systemicTherapy.syst_intention)
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_protokoll', selectedForm.additionalFields.systemicTherapy.syst_protokoll)
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_no_agent', selectedForm.additionalFields.systemicTherapy.syst_no_agent)
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_therapieart', selectedForm.additionalFields.systemicTherapy.syst_therapieart)
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_beginn_datum', selectedForm.date)
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_beginn_datum_genauigkeit', selectedForm.additionalFields.systemicTherapy.syst_beginn_datum_genauigkeit)
        this.$set(this.model, 'agents', selectedForm.agents)

        setTimeout(() => {
          if (this.validationRef) Array.isArray(this.validationRef) ? this.validationRef[0].validate() : this.validationRef.validate()
        }, 200)
      }
    },

    /**
     * Delete linked therapy, when start date should be set manually and trigger save
     */
    unlinkTherapy () {
      this.$delete(this.model, 'linked_therapy')
    },

    /**
     * Add new element to agent list
     */
    addNewAgent () {
      this.$set(this.model.additionalFields.systemicTherapy, 'syst_no_agent', false)
      this.addItem('agents', {})
    },

    /**
     * Set syst_nebenwirkung, if Abortion due to side effects
     *
     * @param endReason
     */
    setSideEffectsPerDefault (endReason) {
      if (endReason && endReason === 'A') {
        if (!this.model.additionalFields.systemicTherapy.syst_nebenwirkung) {
          this.$set(this.model.additionalFields.systemicTherapy, 'syst_nebenwirkung', {})
        }
      } else {
        this.$delete(this.model.additionalFields.systemicTherapy, 'syst_nebenwirkung')
      }
    },

    /**
     * Reset agents, protocol and kind of therapy after clicking checkbox of no agent
     */
    resetNoAgents (value) {
      if (value) {
        delete this.model.agents
        delete this.model.additionalFields.systemicTherapy.syst_protokoll
      }

      // delete kind of therapy only, if it is an active therapy (if syst_no_agent is true)
      // delete also if syst_no_agent is unset (passive therapy will be deleted)
      if ((this.therapiesWithoutAgents.indexOf(this.model.additionalFields.systemicTherapy.syst_therapieart) === -1 && value) || !value) {
        this.$delete(this.model.additionalFields.systemicTherapy, 'syst_therapieart')
      }

      this.$nextTick(() => {
        this.$refs[this.path + '.agents'].validate()
      })
    },

    /**
     * Get list of agents as result of search
     */
    getDataForAutocomplete (data, index) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      // prevent search, when search string has less than 3 letters after clearing
      if (data.length < 3) return

      // reset resultModel to display the correct results after db-request
      this.resultSearchModel = {}

      this.$http.get('/agents/search?config={"opts":{}, "query": {"searchValue":"' + data + '"}}')
        .then(res => {
          // give index of selected array-element to component to ensure, that only popup of selected element will be opened and not all
          res.data.index = index
          this.resultSearchModel = res.data
        })
        .catch(this.NotifyError)
    },

    /**
     * Set agent from list of auto-complete
     *
     * @param data
     * @param index
     */
    setAgent (data, index) {
      if (data && data.Name_deutsch) {
        const agent = {
          bezeichnung: data.Name_deutsch
        }

        // set atc-values, if atc-code exists in selected item from list
        if (data.Key_ATC) {
          agent.atc = {
            code: data.Key_ATC,
            version: new Date().getFullYear().toString()
          }
        }

        this.$set(this.model.agents, index, agent)

        if (!this.model?.additionalFields?.systemicTherapy?.syst_protokoll) {
          let agentsList = ''
          this.model.agents.forEach((agent, index) => {
            if (index > 0) {
              agentsList += ',' + agent.bezeichnung
            } else {
              agentsList += agent.bezeichnung
            }
          })

          // Get therapy types for 'model.syst_substanz'
          this.$http.get('/agents/therapyTypes/' + agentsList)
            .then((res) => {
              if (res.data && (res.data.type || res.data.type === '')) {
                this.$set(this.model.additionalFields.systemicTherapy, 'syst_therapieart', res.data.type || null)

                this.$nextTick(() => {
                  // validate syst_therapieart separately after programmatic change
                  this.$refs[this.path + '.additionalFields.systemicTherapy.syst_therapieart'].validate()
                })
              }
            })
            .catch(this.NotifyError)
        }
      } else {
        this.$set(this.model.agents[index], 'bezeichnung', data)
        this.$set(this.model.agents[index], 'atc', null)
      }
    },

    /**
     * Get list of register protocols codes via regex in auto-complete
     *
     * @param data The Search string
     */
    getProtocolForAutocomplete (data) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)
      // reset resultModel to display the correct results after db-request
      this.resultSearchProtocolModel = {}

      this.$http.get('/protocols/search?config={"opts":{"limit": 30}, "query": {"searchValue":"' + data + '"}}')
        .then(res => {
          this.resultSearchProtocolModel = res.data
        })
        .catch(this.NotifyError)
    },

    /**
     * Create String of agents in list of protocols to show in list of auto complete
     *
     * @param agents Array of agents as string
     */
    setTextForAgentsInList (agents) {
      agents = agents || []
      const length = agents.length
      let returnValue = length > 0 ? 'Wirkstoffe: ' : 'Keine Wirkstoffe'

      agents.forEach((agent, index) => {
        returnValue += agent.bezeichnung
        if (index < length - 1) {
          returnValue += ', '
        }
      })

      return returnValue
    },

    /**
     * Set protocol value, agents, types via list from auto complete
     *
     * @param data The selected object of protocol
     */
    setProtocol (data) {
      // fill only values, if data is an object
      if (data && data.protocol) {
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_therapieart', data.type)
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_protokoll', data.protocol)
        this.$set(this.model, 'agents', data.agents)

        // set boolean of syst_no_agent in dependency to existing agents
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_no_agent', !(data.agents && data.agents.length > 0))

        // validate kind of therapy, if ref exists
        if (this.$refs[this.path + '.additionalFields.systemicTherapy.syst_therapieart']) {
          this.$nextTick(() => {
            this.$refs[this.path + '.additionalFields.systemicTherapy.syst_therapieart'].validate()
          })
        }

        // set oldProtocolData with selected protocol to have chance to delete values
        // of agents and kind of therapies in form after deleting protocol
        this.oldProtocolData = lodash.cloneDeep(data)
      } else if (!data || data !== this.oldProtocolData.protocol) {
        this.$delete(this.model.additionalFields.systemicTherapy, 'syst_therapieart')
        this.$delete(this.model, 'agents')

        this.oldProtocolData = {}
      }
    },

    /**
     * Clear protocol after changing kind of therapy to passive therapy
     *
     * @param kindOfTherapy
     */
    clearProtocol (kindOfTherapy) {
      // delete agents, if selected therapy ist a passive therapy
      if (this.therapiesWithoutAgents.indexOf(kindOfTherapy) > -1) {
        this.$delete(this.model.additionalFields.systemicTherapy, 'syst_protokoll')
        this.$delete(this.model, 'agents')
        this.$set(this.model.additionalFields.systemicTherapy, 'syst_no_agent', true)
      }
    }
  },
  computed: {
    kindOfTherapyIsPassive () {
      return this.model.additionalFields.systemicTherapy.syst_therapieart && this.therapiesWithoutAgents.indexOf(this.model.additionalFields.systemicTherapy.syst_therapieart) > -1
    },
    SystemicTherapyWithSameDateAlreadyExists () {
      // check if in history a systemic therapy with same date already exists and show warning if true
      if (this.model && this.model.reportDisplayName === 'behandlungsbeginn' && this.date && moment(this.date).isValid()) {
        return this.recentForms.find(form => form.formType === 'systemicTherapy' && form.reportType === 'behandlungsbeginn' && moment(this.date).isSame(form.date, 'day'))
      } else {
        return false
      }
    },
    listOfUnlinkedTherapies () {
      let therapyList = this.unlinkedRecentSystemicTherapies.filter(therapy => {
        return therapy.diagnosis_id === this.model.diagnosis && // therapy start must have same diagnosis
          (moment(this.date).isSame(therapy.date, 'day') || moment(this.date).isAfter(therapy.date, 'day')) // therapy start must be older
      })

      if (this.model.reportType === 'behandlungsende' && !this.model.linked_therapy) {
        return therapyList
      } else if (this.model.reportType === 'behandlungsende' && this.model.linked_therapy) {
        const selectedStartTherapy = this.recentForms.find(therapy => therapy.uuid === this.model.linked_therapy)

        // add linked start therapy to list of unlinked therapies, if not exists in list, to show in select-element
        if (selectedStartTherapy && this.unlinkedRecentSystemicTherapies.findIndex(therapy => therapy._id === selectedStartTherapy.uuid) === -1) {
          let listElement = {
            _id: selectedStartTherapy.uuid,
            syst_therapieart: selectedStartTherapy.additionalFields.systemicTherapy.syst_therapieart,
            date: selectedStartTherapy.date,
            syst_substanz: selectedStartTherapy.agents
          }

          const diagnosis = this.recentForms.find(elem => {
            return (elem.uuid && elem.uuid === selectedStartTherapy.diagnosis) || (elem.subjId && elem.subjId === selectedStartTherapy.subjId)
          })

          if (diagnosis?.uuid) {
            listElement.diagnosis_id = diagnosis.uuid
          }

          therapyList.unshift(listElement)
        }

        return therapyList
      } else {
        return []
      }
    },
    selectionForKindOfTherapy () {
      return this.model.additionalFields.systemicTherapy.syst_no_agent ? this.therapiesWithoutAgentsList : this.SYST_TherapyArtTypes
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
          this.isLinkedTherapy = this.model.reportType === 'behandlungsende' && this.model.linked_therapy ? 'J' : 'N'

          if (!this.model.additionalFields) {
            this.$set(this.model, 'additionalFields', {systemicTherapy: {}})
          }
        }
      },
      immediate: true
    },
    'model.diagnosis': {
      handler: function (newValue, oldValue) {
        // delete linked therapy after changing diagnosis
        if (this.model.linked_therapy && newValue && oldValue && newValue !== oldValue) {
          this.unlinkTherapy()
          this.isLinkedTherapy = 'N'
        }
      },
      immediate: true
    },
    'model.additionalFields.systemicTherapy.syst_therapieart': {
      handler: function (newValue) {
        if (newValue) {
          this.$refs[this.path + '.additionalFields.systemicTherapy.syst_therapieart'].validate()

          // wait till next tick to trigger validation to ensure, that element syst_therapieart is known
          this.$nextTick(() => {
            this.$refs[this.path + '.agents'].validate()
          })
        }
      }
    },
    'model.additionalFields.systemicTherapy.syst_protokoll': {
      handler: function (newValue) {
        if (!newValue) {
          // reset oldProtocolData, when generating new additional form
          this.oldProtocolData = {}
        } else if (newValue && Object.keys(this.oldProtocolData).length === 0) {
          // load protocol default data from db, when returning form from history and set oldProtocolData
          this.$http.get('/protocols/search?config={"opts":{"limit": 30}, "query": {"name":"' + this.model.additionalFields.systemicTherapy.syst_protokoll + '"}}')
            .then(res => {
              if (res && res.data && res.data.result && res.data.result.length > 0) {
                this.oldProtocolData = res.data.result[0]
              }
            })
        }
      }
    },
    'model.agents': {
      deep: true,
      handler: function (newValue) {
        if (newValue) {
          this.$refs[this.path + '.agents'].validate()
        }
      }
    }
  }
}
</script>
